import { render } from "./clinic-changepassword.vue?vue&type=template&id=4433f8da&scoped=true"
import script from "./clinic-changepassword.vue?vue&type=script&lang=js"
export * from "./clinic-changepassword.vue?vue&type=script&lang=js"

import "./clinic-changepassword.vue?vue&type=style&index=0&id=4433f8da&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4433f8da"]])

export default __exports__